<default-entity-card
    *ngFor="let entity of showedEntities"
    class="multiline-entity-card"
    [item]="entity"
    [clickable]="false"
>
</default-entity-card>

<button
    fxFlex="none"
    *ngIf="hiddenItems.length"
    class="other-entities"
    [ngClass]="{ 'animate-border': null }"
    [matMenuTriggerFor]="otherItemsPopup"
    (mouseenter)="othersPopup.openMenu()"
    data-unit="other-items-button"
>
    + {{ hiddenItems.length }} other{{ hiddenItems.length > 1 ? 's' : '' }}
</button>

<mat-menu
    class="multiline-entities-list-others-popup"
    #otherItemsPopup="matMenu"
    overlapTrigger="false"
    yPosition="below"
>
    <div
        class="multiline-entities-list-others-box"
        (mouseleave)="othersPopup.closeMenu()"
        (click)="$event.stopPropagation()"
    >
        <div class="content">
            <default-entity-card
                [item]="item"
                [clickable]="false"
                class="multiline-entity-card"
                *ngFor="let item of hiddenItems"
            >
            </default-entity-card>
        </div>
    </div>
</mat-menu>
